import React from 'react';

import { TCategoryValues } from 'components/bellAlerts/types';
import DeltaOffering from 'styles/assets/icons/GiftBox';
import Activities from 'styles/assets/icons/Graph';
import AllBellAlerts from 'styles/assets/icons/Menu';
import DeltaNews from 'styles/assets/icons/NewsLetter';
import SystemUpdates from 'styles/assets/icons/Settings';

import {
  ALL_BELL_ALERTS,
  DELTA_NEWS,
  DELTA_OFFERING,
  SYSTEM_UPDATES,
  ACTIVITIES,
  KYC_VERIFIED,
  WITHDRAWAL,
  DEPOSIT,
} from './constants';

const GetCategoryIcon = ({ categoryName }: { categoryName: TCategoryValues }) => {
  switch (categoryName) {
    case ALL_BELL_ALERTS:
      return <AllBellAlerts />;
    case DELTA_NEWS:
      return <DeltaNews />;
    case DELTA_OFFERING:
      return <DeltaOffering />;
    case SYSTEM_UPDATES:
      return <SystemUpdates />;
    case ACTIVITIES:
    case KYC_VERIFIED:
    case DEPOSIT:
    case WITHDRAWAL:
      return <Activities />;
    default:
      return <AllBellAlerts />;
  }
};

export default GetCategoryIcon;
